import { createShapeNormalizer } from '@change-corgi/fcm/normalizers';

import { defineFcm } from '../shared/factory';

export const FCM_AI_SHARE_HEADLINE_BANDIT = defineFcm('ai_share_headline_bandit')
	.asJson(
		createShapeNormalizer({
			type: 'object',
			shape: {
				enabled: { type: 'boolean' },
				prompt: { type: 'string' },
				model: { type: 'string' }, // FIXME should this be an enum?
			},
		}),
	)
	.withDefault(undefined)
	.toConfig({
		owner: 'squad-starfish',
		scope: 'bandit-service',
		context: 'petition shares',
		description: 'Controls the prompt used for generating share headline bandit options',
		import: false,
		template: {
			enabled: true,
			prompt:
				'A petition on change.org has a title {title} and a description {description}. Create three share headlines that will create the most engagement and signatures on social media. Format your answer as an array of strings.',
			model: 'gpt-4',
		},
	});
